<fury-page>
    <fury-title class="title">
      <span [@fadeInRight]>{{roleId ? 'Update' : 'Add'}} Role</span>
    </fury-title>
  </fury-page>
  <div fxLayout="column" fxLayoutAlign="start center">
    <div [@fadeInUp] class="card">
        <form [formGroup]="roleForm" style="width: 100%;">

          <div class="content" fxLayout="column" fxLayoutGap="8px">
            <mat-form-field appearance="outline" >
              <mat-label>Parent Role</mat-label>
              <mat-select matNativeControl formControlName="parentId" [disabled]="roleType === 'claim'">
                <mat-option value="">N/A</mat-option>
                <mat-option *ngFor="let role of rolList" [value]="role?.roleId">{{role?.title}}</mat-option>
              </mat-select>
              <mat-error
                *ngIf="roleForm.controls['parentId'].touched && roleForm.controls['parentId'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
            <mat-form-field appearance="outline">
              <mat-label>Title</mat-label>
              <input matInput placeholder="Title"
                formControlName="title">
              <mat-error
                *ngIf="roleForm.controls['title'].touched && roleForm.controls['title'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput placeholder="Description" formControlName="description" rows="5"></textarea>
              <mat-error
                *ngIf="roleForm.controls['description'].touched && roleForm.controls['description'].hasError('required')">
                This is a required field.</mat-error>
            </mat-form-field>
 
            <div class="flexInput">
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Is Admin</mat-label>
                <mat-select matNativeControl formControlName="isAdmin">
                  <mat-option [value]="true">Yes</mat-option>
                  <mat-option [value]="false">No</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="roleForm.controls['isAdmin'].touched && roleForm.controls['isAdmin'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" style="width: 100%;">
                <mat-label>Role Type</mat-label>
                <mat-select matNativeControl formControlName="type">
                  <mat-option value="internal">Internal</mat-option>
                  <mat-option value="external">External</mat-option>
                </mat-select>
                <mat-error
                  *ngIf="roleForm.controls['type'].touched && roleForm.controls['type'].hasError('required')">
                  This is a required field.</mat-error>
              </mat-form-field>
            </div>
            <div>
              <span><mat-slide-toggle formControlName="manager">Manager</mat-slide-toggle></span>
              <span style="margin-left: 10px;"><mat-slide-toggle formControlName="statistics">Statistics</mat-slide-toggle></span>
              <span style="margin-left: 10px;"><mat-slide-toggle formControlName="viewOnly">View Only</mat-slide-toggle></span>
            </div>
              <div class="flex">
                <div *ngFor="let item of menuList" class="role_checkbox">
                  <h5 *ngIf="!item.children.length">
                    <input type="checkbox" [disabled]="disabled" [checked]="item?.checked" (change)="parentSelectionChange($event, item)"> {{item.title}}
                  </h5>
                  <h5 *ngIf="item.children.length">
                    <input type="checkbox" [disabled]="disabled" [checked]="item?.checked" (change)="parentSelectionChange($event, item)"> {{item.title}}
                  </h5>
                <fury-role-menu-child (checkedTriggerToParent)="checkedParent($event, item)" [children]="item?.children" [disabled]="disabled"></fury-role-menu-child>
                </div>
              </div>
                
  
          </div>

          <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            <button (click)="addEditRole()" class="sub-button" mat-button
                    type="button">{{roleId ? 'Update' : 'Add'}}</button>
           
          </div>
           
          </form>
    </div>
  </div>
